/**
 * Created by charnjeetelectrovese@gmail.com on 12/5/2019.
 */

// import { serviceFetchProviderRequests } from '../services/ProviderRequest.service';
// import { fetchPRequests } from '../services/User.service';
import store from '../store';
import Constants from '../config/constants';
import {serviceGetDispute, serviceGetDisputeDetail, serviceResolveDispute} from "../services/Dispute.services";
import history from '../libs/history.utils';
import EventEmitter from "../libs/Events.utils";
import ErrorUtils from "../libs/ErrorUtils";

export const FETCH_INIT = 'FETCH_INIT_DISPUTE';
export const FETCHED = 'FETCHED_DISPUTE';
export const FETCHED_FAIL = 'FETCHED_FAIL_DISPUTE';
export const FETCHED_FILTER = 'FETCHED_FILTER_DISPUTE';
// export const NEXT_PREQUESTS = 'NEXT_PREQUESTS';
// export const PREV_PREQUESTS = 'PREV_PREQUESTS';
export const FETCH_NEXT = 'FETCH_NEXT_DISPUTE';
export const FILTER = 'FILTER_DISPUTE';
export const RESET_FILTER = 'RESET_FILTER_DISPUTE';
export const SET_SORTING = 'SET_SORTING_DISPUTE';
export const SET_FILTER = 'SET_FILTER_DISPUTE';
export const SET_PAGE = 'SET_PAGE_DISPUTE';
export const CHANGE_PAGE = 'CHANGE_PAGE_DISPUTE';
export const CHANGE_STATUS= 'CHANGE_STATE_DISPUTE';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_DISPUTE';
export const CREATE_DATA = 'CREATE_DISPUTE';
export const UPDATE_DATA = 'UPDATE_DISPUTE';
export const DELETE_ITEM = 'DELETE_DISPUTE';
export const SELECT_DISPUTE_INIT = 'SELECT_DISPUTE_INIT';
export const SELECT_DISPUTE_DONE = 'SELECT_DISPUTE_DONE';
export const RESOLVE_DISPUTE_INIT = 'RESOLVE_DISPUTE_INIT';
export const RESOLVE_DISPUTE_DONE = 'RESOLVE_DISPUTE_DONE';

export function actionFetchDispute(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetDispute({ index, row: sorting.row, order: sorting.order, ...filter }); // GetDispute
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}


export function actionUpdateDispute(data) {
    // const request = serviceUpdateDispute(data);
    // return (dispatch) => {
    //     request.then((data) => {
    //         if (!data.error) {
    //             dispatch({type: UPDATE_DATA, payload: data.data})
    //         }
    //     })
    // }
}



export function actionChangePageDispute(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

// export function nextPRequestsClick() {
//     return {
//         type: NEXT_PREQUESTS,
//         payload: null,
//     };
// }
//
// export function prevPRequestsClick() {
//     return {
//         type: PREV_PREQUESTS,
//         payload: null,
//     };
// }

export function actionFilterDispute(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusDispute(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
        // request.then((data) => {
        //     dispatch({type: FILTER_PREQUESTS, payload: data});
        //     dispatch({type: FETCHED_PREQUESTS, payload: null});
        // });
    };
}

export function actionResetFilterDispute() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageDispute(page) {
    const stateData = store.getState().dispute;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchDispute(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
    // if (this.props.totalUsers <= ((this.props.currentPage + 1) * 100)) {
    //         // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order);
    //         this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    //     }

}


export function actionGetDisputeDetails(disputeId){
    const req = serviceGetDisputeDetail({ dispute_id: disputeId });
    return dispatch => {
        dispatch({ type: SELECT_DISPUTE_INIT, payload: null });
        req.then((res) => {
            if (!res.error) {
                dispatch({type: SELECT_DISPUTE_DONE, payload: res.data});
            } else {
                history.goBack();
                dispatch({type: SELECT_DISPUTE_DONE, payload: null});
            }
        })
    }
}

export function actionResolveDispute(params) {
    const req = serviceResolveDispute(params);
    return dispatch => {
        dispatch({ type: RESOLVE_DISPUTE_INIT, payload: null });
        req.then((res) => {
            if (!res.error) {
                dispatch({ type: RESOLVE_DISPUTE_DONE, payload: res.data });
                history.push(`/disputes`);
            } else {
                // history.
                dispatch({ type: RESOLVE_DISPUTE_DONE, payload: null });
                ErrorUtils.showError(res.message);
            }
        })
    }
}
